import React from "react";
import styled from "styled-components";

const SidebarLogoDiv = styled.div`
  background: url("../../assets/sidebar-logo.svg") no-repeat 16px center;
`;
const CollapsedSidebarLogoDiv = styled.div`
  background: url("../../assets/sidebar-logo-collapsed.svg") no-repeat 16px center;
`;

const SidebarLogo = ({ isCollapsed }) =>
  isCollapsed ? (
    <CollapsedSidebarLogoDiv className="collapsed-sidebar-logo" />
  ) : (
    <SidebarLogoDiv className="sidebar-logo" />
  );

export default SidebarLogo;
